import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { fetchCurrentWeather } from './currentWeatherActions'
import './currentWeatherNavBar.pcss'

/**
 * Self contained weather widget for top menu.
 */
const CurrentWeatherNavBar = () => {
  const dispatch = useDispatch()
  const failedToLoad = useSelector((state) => state.currentWeather.get('failedToLoad'))
  const locationName = useSelector((state) => state.currentWeather.get('locationName'))
  const temperature = useSelector((state) => state.currentWeather.get('temperature'))
  const symbol = useSelector((state) => state.currentWeather.get('symbol'))

  // Timer runs every 5 seconds, that gives *opportunity* to fetch current weather.
  // fetchCurrentWeather() contains logic to determine if fetch is actually needed.
  useEffect(() => {
    const updateInterval = setInterval(() => {
      if (!window.document.hidden) {
        dispatch(fetchCurrentWeather(120))
      }
    }, 5000)
    return () => clearInterval(updateInterval)
  }, [dispatch])

  if (failedToLoad) {
    return (
      <span className='menu-weather__error' title='Säätietoja ei saatu ladattua'>
        <i className='fa fa-exclamation' />
      </span>
    )
  }

  const signed = temperature > 0 ? `+${temperature}` : `${temperature}`
  return (
    <div className='menu-weather'>
      <div className='menu-weather__symbol-container'>
        <div className='weather-symbol'>
          <span className={ symbol } />
        </div>
      </div>
      <div className='menu-weather__data'>
        <div className='menu-weather__temp'>{ signed }<span className='menu-weather__degree'> &deg;C</span></div>
        <div className='menu-weather__location'>{ locationName }</div>
      </div>
    </div>
  )
}

export default CurrentWeatherNavBar
